import { forwardRef } from "react";
import { FaEye, FaInfo, FaLink, FaStar } from "react-icons/fa";
import { GoIssueOpened, GoRepoForked } from "react-icons/go";

const RepoItem = ({ repo }) => {
  const {
    name,
    description,
    html_url,
    forks,
    open_issues,
    watchers_count,
    stargazers_count,
  } = repo;
  return (
    <div className="mb-2 rounded-md card bg-white hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-900">
      <div className="card-body">
        <h3 className="mb-2 text-xl font-semibold">
          <a href={html_url}>
            <FaLink className="inline mr-1 " />
            {name}
          </a>
        </h3>
        <p className="mb-3">{description}</p>
        <div className="">
          <div className="mr-2 lg:mr-1 badge badge-info badge-lg">
            <FaEye className="mr-2" />
            {watchers_count}
          </div>
          <div className="mr-2 lg:mr-1 badge badge-sucess badge-lg">
            <FaStar className="mr-2" />
            {stargazers_count}
          </div>
          <div className="mr-2 lg:mr-1 badge badge-error badge-lg">
            <GoIssueOpened className="mr-2" />
            {open_issues}
          </div>

          <div className="mr-2 lg:mt-2 badge lg:mr-1 badge-warning badge-lg">
            <GoRepoForked className="mr-2" />
            {forks}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepoItem;
